import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function ClosingCTASection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-47">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(34,197,94,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-48" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-50">
          <p className="text-xl text-gray-400 mb-8 leading-relaxed" data-id="element-51">
            Hay algo que cambia cuando empezás a producir tu comida:
          </p>

          <div className="space-y-3 mb-10" data-id="element-52">
            {['Sentís control.', 'Sentís calma.', 'Sentís independencia.'].map((line, i) => <motion.p key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + i * 0.15,
            duration: 0.5
          }} className="text-3xl md:text-4xl font-black text-white" data-id="element-53">
                  {line}
                </motion.p>)}
          </div>

          <p className="text-lg text-gray-400 mb-4" data-id="element-54">
            Y lo mejor es que no necesitás "saber de huerta".{' '}
            <span className="text-white font-bold" data-id="element-55">Necesitás un sistema.</span>
          </p>

          <p className="text-xl font-bold text-white mb-10" data-id="element-56">
            Huerta Productiva 360° ya está armado para vos.
          </p>

          <motion.div whileInView={{
          scale: [0.95, 1.02, 1]
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-57">
            <Button size="xl" onClick={scrollToCheckout} className="group text-xl px-12 py-6" data-id="element-58">
              QUIERO MI HUERTA 360° AHORA
              <ArrowDown className="ml-3 w-6 h-6 group-hover:translate-y-1 transition-transform" data-id="element-59" />
            </Button>
          </motion.div>

          <p className="mt-6 text-zinc-600 text-sm" data-id="element-60">
            Acceso inmediato · Pago seguro · Garantía 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}